import PropTypes from 'prop-types';
import Figure from '../../Figure/Figure';

function AnimationFigureMultipleLines({ className, mediaContainerClassName, imgs, hasCreditsPopin, credits, hasCaption, caption }) {
    let containerClasses = `animation-figure animation-figure--multiple-lines ${className}`;

    return <Figure
        className={containerClasses}
        mediaContainerClassName={mediaContainerClassName}
        medias={imgs}
        hasCreditsPopin={hasCreditsPopin}
        credits={credits}
        hasCaption={hasCaption}
        caption={caption} />;
}

AnimationFigureMultipleLines.propTypes = {
    className: PropTypes.string,
    mediaContainerClassName: PropTypes.string,
    imgs: PropTypes.object.isRequired,
    hasCreditsPopin: PropTypes.bool.isRequired,
    credits: PropTypes.element,
    hasCaption: PropTypes.bool.isRequired,
    caption: PropTypes.element,
}

export default AnimationFigureMultipleLines;
